exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout[data-v-302679ab]{padding:12px;border:1px solid #d5d5d8;background-color:#fff;border-radius:4px}.layout__header[data-v-302679ab]{color:#62626c;font-size:14px;font-weight:bold}.layout__body[data-v-302679ab]:nth-child(n+2){padding-top:12px;border-top:1px solid #d5d5d8;margin-top:8px}", ""]);

// exports
